<template>
    <Layout>
        <Titlebar :title="title" :links="links" />
        <Table :table="table" />
    </Layout>
</template>

<script>
    import { table } from '@/Mixins'
    import Table from '@/Components/Table'

    export default {
        mixins: [table],
        components: {
            Table
        },
        methods: {
        }
    }
</script>
